<div class="container mx-auto px-4 py-6">
  <div class="sticky z-40 bg-white pb-3" style="top: 64px;">
    <!-- Header -->
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800 mb-2">
        Walk-in Clients Revenue Report
      </h1>
      <p class="text-gray-600">
        One row per walk-in extra charge. No client record is created for walk-ins.
      </p>
    </div>

    <!-- Filters -->
    <search class="lg:w-full mt-4" tuiSearch style="padding-left: 0">
      <fieldset class="flex items-center gap-4 border-none">
        <div class="w-[300px]">
          <tui-textfield iconStart="@tui.search">
            <input [formControl]="searchControl" placeholder="Search by name, contact, procedure, nurse" tuiTextfield />
          </tui-textfield>
        </div>

        <div class="w-[180px]">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="rangeFilterControl"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let type of rangeFilterTypes" [value]="type">
              {{ type }}
            </option>
          </select>
        </div>

        <div class="flex gap-2" *ngIf="rangeFilterControl.value === 'Monthly'">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="monthControl"
            class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label }}
            </option>
          </select>

          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="yearControl"
            class="w-[100px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let year of years" [value]="year">
              {{ year }}
            </option>
          </select>
        </div>

        <div class="min-w-[280px]" *ngIf="rangeFilterControl.value === 'Custom Range'">
          <tui-input-date-range [formControl]="customRangeControl">
            Choose date range
            <input placeholder="From - To" tuiTextfieldLegacy />
          </tui-input-date-range>
        </div>

        <button (click)="applyFilters()" appearance="secondary" size="m" tuiButton type="button"
          class="w-full sm:w-auto" style="border: 2px solid #e5e7ea; font-weight: 800">
          Search
        </button>

        <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="clearFilters()">
          Clear
        </button>
        <div class="flex justify-end gap-3">
          <button tuiButton appearance="primary" size="m" (click)="exportToExcel()"
            [disabled]="filteredData.length === 0">
            Export to Excel
          </button>
        </div>
      </fieldset>
    </search>

  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <tui-loader size="xl" [overlay]="true"></tui-loader>
  </div>

  <!-- Report -->
  <div *ngIf="!loading" id="printable-report" class="bg-white rounded-lg shadow-md overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Service Date
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Invoice Number
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Client Name
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Contact
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Procedures
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Nurse
            </th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Total
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider no-print">
              Action
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of filteredData" class="hover:bg-gray-50 transition-colors"
            [class.bg-amber-50]="item.recordArchived">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.invoiceDate | date : "MM/dd/yyyy" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.invoiceNumber }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.clientName }}
              <app-client-archived-badge [visible]="!!item.recordArchived"></app-client-archived-badge>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
              {{ item.contactNumber || '—' }}
            </td>
            <td class="px-6 py-4 text-sm text-gray-700">
              {{ (item.procedures || []).join(', ') || '—' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
              {{ item.nurseName || '—' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 font-semibold">
              LKR {{ item.total | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm no-print">
              <a *ngIf="item.procedureId" [routerLink]="['/walk-in-invoice', item.procedureId]"
                class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800">
                View Invoice
              </a>
            </td>
          </tr>

          <tr class="bg-blue-50 font-bold" *ngIf="filteredData.length > 0">
            <td colspan="6" class="px-6 py-4 text-right text-sm text-gray-900">
              TOTAL:
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-blue-700">
              LKR {{ grandTotal | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 no-print"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="filteredData.length === 0" class="text-center py-12 text-gray-500">
      <p class="text-lg">No data found</p>
      <p class="text-sm mt-2">Try adjusting your filters</p>
    </div>
  </div>

  <div *ngIf="!loading && filteredData.length > 0" class="mt-6">
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-sm font-medium text-gray-500 mb-2">Grand Total</h3>
      <p class="text-2xl font-bold text-orange-600">
        LKR {{ grandTotal | number : "1.2-2" }}
      </p>
    </div>
  </div>
</div>